import { EtudeForm } from "components/EtudeForm";
import React from "react";

export const EtudePage: React.FC = () => {
  return <EtudeForm />;
};
